import { createContext, ReactNode, useContext } from "react";

export const useApplicationRootUrl = () => `/${useContext(ApplicationRootContext).rootUrl}`;
export const useApplicationRoot = () => useContext(ApplicationRootContext).rootUrl;
export const useApplicationAuthType = () => useContext(ApplicationRootContext).authType;
export const useApplicationIsInternalAuth = () => useContext(ApplicationRootContext).authType === 'internal';
export const useApplicationIsProviderCPSupport = () => useContext(ApplicationRootContext).authType === 'internal' 
                                                && useContext(ApplicationRootContext).rootUrl === ApplicationRootUrl.AZURE_INTERNAL_CP_PROVIDER_ROUTE_NAME;

export enum ApplicationRootUrl {
    AZURE_INTERNAL_CP_ROUTE_NAME = 'internal-cp',
    AZURE_INTERNAL_UM_ROUTE_NAME = 'internal-um',
    AZURE_INTERNAL_CP_PROVIDER_ROUTE_NAME = 'internal-cp-provider',
    AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME = 'internal-eum',
    EXTERNAL_PROVIDER_APP_ROOT_URL = 'provider',
    EXTERNAL_EUM_APP_ROOT_URL = 'eum',
}
export type ApplicationRootUrlType = `${ApplicationRootUrl}`;

export type ApplicationAuthType = 'external' | 'internal';
export const ApplicationRootContext = createContext<{rootUrl: ApplicationRootUrlType , authType: ApplicationAuthType}>({
    rootUrl: ApplicationRootUrl.EXTERNAL_PROVIDER_APP_ROOT_URL,
    authType: 'external'
});

export const ApplicationRootProvider = ({children, rootUrl, authType }: {children: ReactNode, rootUrl: ApplicationRootUrlType, authType: 'external' | 'internal'}) => {
    return (
        <ApplicationRootContext.Provider value={{rootUrl, authType}}>
            {children}
        </ApplicationRootContext.Provider>
    );
}